export const rgbaToRgb = (rgba) => {
    const unspaced = rgba.replace(/\s/g, '');
    return unspaced.replace(/,\d{1}\)/, ')');
};
//# sourceMappingURL=helpers.js.map